import cn from 'clsx';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NamedIcon from '@v2/shared/components/NamedIcon';

type Props = {
  href: string;
  /** A statically imported icon, for the fixed menu entries. */
  icon?: IconProp;
  /** A jss_sections.icon value, for entries built from category data. */
  iconName?: string | null;
  title: string;
};

export default function Item({ href, title, icon, iconName }: Props) {
  return (
    <a
      href={href}
      className={cn(
        'group px-4 py-2.5 flex justify-between items-center border-b-[1.5px] border-slate-100 last-of-type:border-b-0 cursor-pointer',
        'hover:bg-slate-50'
      )}
    >
      <span className="text-base font-medium flex items-center text-slate-700 group-hover:text-black">
        {(icon || iconName !== undefined) && (
          <div className="w-7 h-7 flex items-center justify-center rounded bg-slate-100 text-slate-900 mr-2">
            {icon ? <FontAwesomeIcon icon={icon} /> : <NamedIcon name={iconName} />}
          </div>
        )}
        {title}
      </span>
      <FontAwesomeIcon icon={faAngleRight} className="text-2xl text-slate-300 mr-1 group-hover:text-slate-600" />
    </a>
  );
}
